import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { PermissionsAllDirective } from './permissions-all/permissions-all.directive';
import { ResourceLanguageDirective } from './resource-language/resource-language.directive';
import { FocusOnInitDirective } from './focus-on-init/focus-on-init.directive';
import { FocusAutosaveDirective } from './focus-autosave/focus-autosave.directive';
import { PermissionsAnyDirective } from './permissions-any/permissions-any.directive';
import { AreBuildingsRequiredDirective } from './are-buildings-required/are-buildings-required.directive';
import { AutoResizeDirective } from './auto-resize/auto-resize.directive';
import { NestedDirective } from './nested/component/nested.directive';
import { FilterNestedPipe } from './nested/pipes/filter-nested/filter-nested.pipe';
import { CountNestedPipe } from './nested/pipes/count-nested/count-nested.pipe';
import { HasNestedPipe } from './nested/pipes/has-nested/has-nested.pipe';
import { NestedHelpersService } from './nested/service/nested-helpers.service';
import { EdlCommonDirectiveModule } from '@edl-development/edl-common';
import { ClickableRowDirective } from './clickable-row.directive';

@NgModule({
    imports: [
        CommonModule,
        EdlCommonDirectiveModule
    ],
    providers: [
        NestedHelpersService
    ],
    declarations: [
        AreBuildingsRequiredDirective,
        PermissionsAllDirective,
        PermissionsAnyDirective,
        ResourceLanguageDirective,
        FocusOnInitDirective,
        FocusAutosaveDirective,
        AutoResizeDirective,
        NestedDirective,
        FilterNestedPipe,
        CountNestedPipe,
        HasNestedPipe,
        ClickableRowDirective
    ],
    exports: [
        AreBuildingsRequiredDirective,
        PermissionsAllDirective,
        PermissionsAnyDirective,
        ResourceLanguageDirective,
        FocusOnInitDirective,
        FocusAutosaveDirective,
        AutoResizeDirective,
        NestedDirective,
        FilterNestedPipe,
        CountNestedPipe,
        HasNestedPipe,
        ClickableRowDirective
    ]
})
export class PaetepDirectiveModule { }